module.exports = __webpack_public_path__ + "img/bert-benefit-3.b6393278.png";